import { Extension } from '@tiptap/core'
import { createInterpolationPlugin } from '~/admin/components/prosemirror/plugins/interpolation'

export const Interpolation = Extension.create({
  name: 'interpolation',

  addProseMirrorPlugins() {
    return [createInterpolationPlugin('tiptap-interpolation')]
  },
})
